@let hasResults = data() && data()!.length > 0 && !isLoading();
@let shouldShowHeader = (showHeader() || hasResults) && !isLoading();
<div [attr.data-testid]="id()">
  <div [ngClass]="resolvedTableClasses()" #table>
    @if (isLoading()) {
      <div class="py-5">
        <aw-loading-animation></aw-loading-animation>
      </div>
    }
    @if (shouldShowHeader) {
      <div
        [ngClass]="resolvedHeaderClasses()"
        [attr.data-testid]="id() | appendTestId: 'header'">
        <ng-container
          *ngTemplateOutlet="
            header();
            context: { sortBy: sortBy }
          "></ng-container>
      </div>

      @for (
        dataPoint of currentPageData();
        track rowKey() ? rowKey()!(dataPoint, $index) : $index;
        let index = $index
      ) {
        <div
          [ngClass]="[
            resolvedRowClasses(),
            striped() && index % 2 === 1 ? 'bg-standard-divider/50' : '',
          ]"
          [attr.data-testid]="id() | appendTestId: 'row-' + index">
          <ng-container
            *ngTemplateOutlet="
              columns();
              context: {
                data: dataPoint,
                index: index,
                toggleExpanded: toggleExpanded.bind(this),
                isExpanded: isExpanded.bind(this),
              }
            "></ng-container>
        </div>

        @if (
          expandable() && expandedRowTemplate() && isExpanded(dataPoint, index)
        ) {
          <div
            class="border-standard-outline bg-standard-hover-main/20 border-b p-3"
            [attr.data-testid]="id() | appendTestId: 'expanded-row-' + index">
            <ng-container
              *ngTemplateOutlet="
                expandedRowTemplate()!;
                context: { data: dataPoint, index: index }
              "></ng-container>
          </div>
        }
      }
    }
    @if ((!data() || data()!.length === 0) && !isLoading()) {
      <div
        class="flex flex-row justify-center p-4"
        [attr.data-testid]="id() | appendTestId: 'noEntries'">
        {{ labels().noEntriesFoundMessage }}
      </div>
    }
  </div>
  @if (hasResults) {
    <div
      class="flex flex-row items-center justify-between pt-4 text-sm"
      [attr.data-testid]="id() | appendTestId: 'dataInfo'">
      @if (showNumberOfEntries()) {
        <div class="text-md text-standard-text-secondary">
          {{ labels().entriesText }} {{ currentPage() * pageSize() + 1 }}-{{
            data()!.length < currentPage() * pageSize() + pageSize()
              ? data()!.length
              : currentPage() * pageSize() + pageSize()
          }}
          {{ labels().ofEntriesText }}
          {{ data()!.length }}
        </div>
      }
      <div class="flex flex-row items-center gap-6">
        <button
          aria-label="Erste Seite"
          type="button"
          (click)="setCurrentPage(0)"
          [disabled]="currentPage() === 0"
          [id]="id() | appendTestId: 'firstPage'"
          [attr.data-testid]="id() | appendTestId: 'firstPage'"
          aria-label="Erste Seite"
          class="material-symbols-rounded hover:text-primary-main disabled:text-standard-text-disabled cursor-pointer disabled:cursor-not-allowed">
          keyboard_double_arrow_left
        </button>

        <button
          type="button"
          (click)="previousPage()"
          [disabled]="currentPage() === 0"
          [id]="id() | appendTestId: 'previousPage'"
          [attr.data-testid]="id() | appendTestId: 'previousPage'"
          aria-label="Vorherige Seite"
          class="material-symbols-rounded hover:text-primary-main disabled:text-standard-text-disabled cursor-pointer disabled:cursor-not-allowed">
          chevron_left
        </button>

        <div [attr.data-testid]="id() | appendTestId: 'currentPage'">
          {{ currentPage() + 1 }} von {{ maxPage() }}
        </div>

        <button
          type="button"
          (click)="nextPage()"
          [disabled]="currentPage() === maxPage() - 1"
          [id]="id() | appendTestId: 'nextPage'"
          [attr.data-testid]="id() | appendTestId: 'nextPage'"
          aria-label="Nächste Seite"
          class="material-symbols-rounded hover:text-primary-main disabled:text-standard-text-disabled cursor-pointer disabled:cursor-not-allowed">
          chevron_right
        </button>

        <button
          type="button"
          (click)="setCurrentPage(maxPage() - 1)"
          [disabled]="currentPage() === maxPage() - 1"
          [id]="id() | appendTestId: 'lastPage'"
          [attr.data-testid]="id() | appendTestId: 'lastPage'"
          aria-label="Letzte Seite"
          class="material-symbols-rounded hover:text-primary-main disabled:text-standard-text-disabled cursor-pointer disabled:cursor-not-allowed">
          keyboard_double_arrow_right
        </button>
      </div>
      @if (showPageSizeSelect()) {
        <div
          class="flex flex-row items-center gap-4"
          [attr.data-testid]="id() | appendTestId: 'pageSize'">
          {{ labels().entriesPerPageText }}
          <div class="w-20">
            <aw-drop-down
              [id]="id() | appendTestId: 'pageSizeSelect'"
              [options]="pageSizeOptions()"
              appearance="compact"
              [formControl]="pageSizeControl"></aw-drop-down>
          </div>
        </div>
      }
    </div>
  }
</div>
